// extracted by mini-css-extract-plugin
export default {"option":"hRTxZp6hnomdOYXixUwt","switch":"oirDzwxNNPoxjOqsb0rW"};